import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import BondsWithoutMaturityDateReportCriteria from './BondsWithoutMaturityDateReportCriteria';

@NeoReport("BondsWithoutMaturityDate",  { category: MaintenanceReportCategories.DataEnrichmentReports})
export default class BondsWithoutMaturityDateReport extends Report<BondsWithoutMaturityDateReportCriteria>{

    constructor() {
        super(BondsWithoutMaturityDateReportCriteria);
    }

    public renderCriteria() {
        return (<></>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}